import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { RootState } from "src/redux/reducers";

export default function useGetUserAvatarUrl() {
  const [avatarUrl, setAvatarUrl] = useState("");

  const { identity } = useSelector((state: RootState) => state.mainReducer);

  useEffect(() => {
    if (identity?.avatar) {
      setAvatarUrl(
        identity?.avatar?.thumbnails.tiny || identity?.avatar?.publicUrl,
      );
    }
  }, [identity?.avatar]);

  return avatarUrl;
}
